import { fetchAuthSession } from 'aws-amplify/auth';

const API_URL = process.env.REACT_APP_API_PROD_URL;

export const getMarkerList = async (lastEvaluatedKey = null, limit = 10) => {
  const { tokens } = await fetchAuthSession({ forceRefresh: true });
  const authJWT = tokens.idToken.toString();

  const url = new URL(`${API_URL}/admin/marker`);
  url.searchParams.append('limit', limit);
  if (lastEvaluatedKey) {
    url.searchParams.append('lastEvaluatedKey', lastEvaluatedKey);
  }

  try {
    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${authJWT}`,
      },
    });

    if (!response.ok) {
      throw new Error('Errore durante il recupero dei marker');
    }

    return await response.json();
  } catch (error) {
    console.error('Errore:', error);
    throw error;
  }
};

export const editMarker = async (id) => {
  const { tokens } = await fetchAuthSession({ forceRefresh: true });
  const authJWT = tokens.idToken.toString();

  try {
    const response = await fetch(`${API_URL}/admin/marker`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${authJWT}`,
      },
      body: JSON.stringify({ id: id }),
    });

    if (!response.ok) {
      throw new Error('Errore durante la modifica del marker');
    }

    return await response.json();
  } catch (error) {
    console.error('Errore:', error);
    throw error;
  }
};